import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Button,
  Modal,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import SliderDetails from "../../Components/Expereince/Slider";
import AddToCart from "../../Components/Expereince/AddToCart";
import { theme } from "../../Assets/Theme/theme";
import CloseIcon from "@mui/icons-material/Close";
import DetailsSection from "../../Components/Expereince/DetailsSection";
import MapComponent from "../../Components/Common/MapComponent";
import Reviews from "../../Components/Expereince/Reviews";
import Container from "../../Components/Layout/Container";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import { useParams, useLocation, useNavigate } from "react-router-dom"; // Added useNavigate
import axios from "axios";
import { BASE_URL } from "../../Assets/Constants";
import { toast } from "react-toastify";
import { CurrencyContext } from "../../Services/CurrencyContext";

function ExperienceDetail() {
  const { currency, setCurrency } = useContext(CurrencyContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [loading, setLoading] = useState(true);
  const [experiencesData, setExperiencesData] = useState([]);
  const [dateData, setDateData] = useState([])
  const [selectedPosition, setSelectedPosition] = useState([30.3753, 69.3451]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showMoreNeeded, setShowMoreNeeded] = useState(false);
  const termRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  // Get experience ID from URL params (Option 1)
  const { experienceId, experienceName } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  // Try to get experience ID from URL params first, then from state as fallback
  const actualExperienceId = experienceId || location?.state?.experienceId;

  useEffect(() => {
    if (!loading && !experiencesData) {
      setTimeout(() => {
        window.location.href  = '/'
      }, 1000);
    }
  }, [])
  

  useEffect(() => {
    if (termRef.current) {
      const lineHeight = parseFloat(getComputedStyle(termRef.current).lineHeight);
      const maxHeight = 2 * lineHeight;
      setShowMoreNeeded(termRef.current.scrollHeight > maxHeight);
    }
  }, [experiencesData?.termAndCondition]);

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  useEffect(() => {
    if (termRef.current) {
      const lineHeight = parseFloat(getComputedStyle(termRef.current).lineHeight);
      const maxHeight = 1 * lineHeight; 
      setShowMoreNeeded(termRef.current.scrollHeight > maxHeight);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchCoordinates = async () => {
      if (!experiencesData?.location) {
        console.warn("Location is undefined or null, using default location.");
        setSelectedPosition([37.0902, -95.7129]);
        return;
      }

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
            experiencesData.location
          )}&format=json&limit=1`
        );
        const result = await response.json();

        if (Array.isArray(result) && result?.length > 0 && result[0] !== null) {
          const lat = result[0]?.lat ? parseFloat(result[0].lat) : null;
          const lon = result[0]?.lon ? parseFloat(result[0].lon) : null;

          if (lat !== null && lon !== null) {
            setSelectedPosition([lat, lon]);
          } else {
            console.warn("No valid coordinates found, using default location.");
            setSelectedPosition([37.0902, -95.7129]);
          }
        } else {
          console.warn("Invalid API response or empty array, using default location.");
          setSelectedPosition([37.0902, -95.7129]);
        }
      } catch (error) {
        console.error("Error fetching coordinates:", error);
        setSelectedPosition([37.0902, -95.7129]);
      }
    };

    fetchCoordinates();
  }, [experiencesData?.location]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const fetchExperiences = async (selectedCurrency) => {
    // Check if we have a valid experience ID
    if (!actualExperienceId) {
      toast.error("Experience ID not found", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setLoading(false);
      // Optionally redirect to experiences page
      setTimeout(() => navigate("/experience"), 2000);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${BASE_URL}/user/experience/${actualExperienceId}`,
        { currencysymbol: selectedCurrency }
      );

      if (!response.data.data) {
        toast.error("This experience is no longer available");
        setExperiencesData(null)
      }

      if (response.data?.data) {
        setExperiencesData(response.data.data);
        setDateData(response.data?.dates);
      } else {
        toast.error("Experience not found", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        // Redirect to experiences page after showing error
        setTimeout(() => navigate("/experience"), 2000);
      }
    } catch (error) {
      console.error("Error fetching experience:", error);
      
      // Handle different error scenarios
      if (error.response?.status === 404) {
        toast.error("Experience not found", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setTimeout(() => navigate("/experience"), 2000);
      } else {
        toast.error(
          error?.response?.data?.error || "Failed to fetch experience details.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCommentPosted = () => {
    fetchExperiences(currency);
  };

  useEffect(() => {
    // Only fetch if we have a valid experience ID
    if (actualExperienceId) {
      fetchExperiences(currency);
    }
  }, [currency, actualExperienceId]);

  // Show loading spinner
  if (loading) {
    return (
      <>
        <style>{loaderStyle.spinnerAnimation}</style>
        <div style={loaderStyle.loaderContainer}>
          <div style={loaderStyle.spinner}></div>
        </div>
      </>
    );
  }

  // Show error state if no experience ID or data
  if (!actualExperienceId || !experiencesData) {
    return (
      <>
        <Navbar currency={currency} />
        <Container>
          <Box 
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "50vh",
              textAlign: "center",
              gap: 2
            }}
          >
            <Typography variant="h4" color="error">
              Experience Not Found
            </Typography>
            <Typography variant="body1" color="textSecondary">
              The experience you're looking for doesn't exist or has been removed.
            </Typography>
            <Button 
              variant="contained" 
              onClick={() => navigate("/experience")}
              sx={{ backgroundColor: theme.colors.orange }}
            >
              Browse All Experiences
            </Button>
          </Box>
        </Container>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar currency={experiencesData?.currency || currency} />{" "}
      <Box>
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} md={8.5}>
              <SliderDetails data={experiencesData} />
              <Box
                sx={{
                  mt: 2,
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    color: theme.colors.text,
                  }}
                >
                  {experiencesData?.name}
                </Typography>
              </Box>
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: { md: "80%", sm: "100%" },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: theme.colors.text,
                  }}
                >
                  {experiencesData?.type}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 1,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: theme.colors.black, mr: 0.5, mt: 0.5 }}
                  >
                    {experiencesData?.ratings?.length > 0 ? experiencesData?.ratings[0]?.rating : 0}
                  </Typography>
                  <StarIcon sx={{ color: theme.colors.orange }} />
                </Box>
              </Box>
              <DetailsSection data={experiencesData} />
            </Grid>

            {!isMobile && (
              <Grid item xs={12} md={3.5}>
                <AddToCart data={experiencesData} dateData={dateData} />
              </Grid>
            )}
          </Grid>
          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
            Map
          </Typography>
          <Box>
            <MapComponent data={experiencesData} selectedPosition={selectedPosition} drag />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
            Terms and Conditions
          </Typography>

          <Typography
            ref={termRef}
            sx={{
              color: theme.colors.textLight,
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: isExpanded ? "unset" : 2,
              overflow: "hidden",
            }}
            dangerouslySetInnerHTML={{ __html: experiencesData?.termAndCondition }}
          />

          {showMoreNeeded && (
            <Typography
              variant="h4"
              onClick={() => setIsExpanded(!isExpanded)}
              sx={{
                fontWeight: 600,
                mt: 1,
                mb: 1,
                cursor: "pointer",
                textDecoration: isHovered ? "underline" : "none",
                fontSize: "15px",
                color: theme.colors.orange,
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {isExpanded ? "Show less" : "Show more"}
            </Typography>
          )}

          <Modal open={openModal} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 500,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 3,
                borderRadius: 2,
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                Terms and Conditions
              </Typography>
              <Typography
                sx={{ color: theme.colors.textLight }}
                dangerouslySetInnerHTML={{ __html: experiencesData?.termAndCondition }}
              />
              <Button variant="contained" sx={{ mt: 2, backgroundColor: theme.colors.orange }} onClick={handleClose}>
                Close
              </Button>
            </Box>
          </Modal>
          <Box>
            <Reviews
              data={experiencesData}
              onCommentPosted={handleCommentPosted}
            />
          </Box>

          {isMobile && (
            <>
              <Button
                variant="contained"
                sx={{
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: theme.colors.orange,
                  color: "#fff",
                  textAlign: "center",
                  height: "60px",
                  borderRadius: 0,
                  fontWeight: "600",
                  zIndex: 1000,
                  ":hover": {
                    backgroundColor: "darkorange",
                  },
                }}
                onClick={handleOpenModal}
              >
                Book your slot
              </Button>

              <Modal
                open={isModalOpen}
                onClose={handleCloseModal}
                aria-labelledby="add-to-cart-modal"
                aria-describedby="add-to-cart-modal-description"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "#fff",
                    borderRadius: 0,
                    boxShadow: 24,
                    p: 3,
                    outline: "none",
                    overflowY: "auto",
                    overflowX: "hidden",
                    position: "relative",
                  }}
                >
                  <IconButton
                    onClick={handleCloseModal}
                    sx={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      color: theme.colors.textLight,
                      zIndex: 10,
                    }}
                  >
                    <CloseIcon />
                  </IconButton>

                  <AddToCart data={experiencesData} dateData={dateData} />
                </Box>
              </Modal>
            </>
          )}
        </Container>
      </Box>
      <Footer />
    </>
  );
}

const loaderStyle = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f9f9f9",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid rgba(0, 0, 0, 0.1)",
    borderTop: "5px solid #FF7900",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  spinnerAnimation: `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
};

export default ExperienceDetail;